module.exports = __webpack_public_path__ + "static/img/01.607402f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/01.png
// module id = hKYS
// module chunks = 1